import { render } from "./SelectInput.vue?vue&type=template&id=476f9622&scoped=true&ts=true"
import script from "./SelectInput.vue?vue&type=script&lang=ts"
export * from "./SelectInput.vue?vue&type=script&lang=ts"

import "./SelectInput.vue?vue&type=style&index=0&id=476f9622&scoped=true&lang=css"

import exportComponent from "/builds/entersekt/repos/sdk-browser/saas-spa/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-476f9622"]])

export default __exports__